import {
  isSessionErrorCode,
  SessionErrorCode,
} from './sessionErrorCodes';

type SessionMessages = Record<'TITLE' | 'DEFAULT' | SessionErrorCode, string>;

const SESSION_ERROR_MESSAGES: Record<'es' | 'en', SessionMessages> = {
  es: {
    TITLE: 'Sesión finalizada',
    SESSION_REPLACED:
      'Se ha iniciado sesión con tu cuenta desde otro dispositivo. Por seguridad, hemos cerrado esta sesión.',
    DEVICE_REVOKED:
      'Este dispositivo ha sido desconectado de tu cuenta. Vuelve a iniciar sesión para continuar.',
    REAUTH_REQUIRED: 'Necesitas iniciar sesión de nuevo para continuar.',
    DEFAULT: 'Tu sesión ha finalizado. Vuelve a iniciar sesión para continuar.',
  },
  en: {
    TITLE: 'Session ended',
    SESSION_REPLACED:
      'Your account was signed in from another device. For security, this session has been closed.',
    DEVICE_REVOKED:
      'This device was disconnected from your account. Sign in again to continue.',
    REAUTH_REQUIRED: 'You need to sign in again to continue.',
    DEFAULT: 'Your session has ended. Sign in again to continue.',
  },
};

function getLang(): 'es' | 'en' {
  const key = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig';
  try {
    const config = JSON.parse(localStorage.getItem(key) || '{}') as {
      selectedLang?: string;
    };
    return config.selectedLang === 'en' ? 'en' : 'es';
  } catch {
    return 'es';
  }
}

function showSessionErrorAlert(code?: SessionErrorCode) {
  const messages = SESSION_ERROR_MESSAGES[getLang()];
  const key = code && isSessionErrorCode(code) ? code : 'DEFAULT';
  window.alert(`${messages.TITLE}\n\n${messages[key]}`);
}

export function createSessionInvalidateGate() {
  let locked = false;

  return {
    beginVoluntaryLogout() {
      locked = true;
    },
    handleSessionInvalidation(
      code: SessionErrorCode | undefined,
      dispatchLogout: () => void,
    ) {
      if (locked) {
        return;
      }
      locked = true;
      dispatchLogout();
      showSessionErrorAlert(code);
    },
    reset() {
      locked = false;
    },
    isLocked() {
      return locked;
    },
  };
}

/** Shared gate for RTK and axios interceptors. */
export const sessionInvalidateGate = createSessionInvalidateGate();
